import {inject, Injectable} from '@angular/core';
import {EMPTY, Observable} from 'rxjs';
import {LayoutToastService} from '../services/layout-toast.service';
import {LAYOUT_THEME} from '@shared/di/layout-theme.token';
import {AbstractPageComponent} from './abstract-page.component';
import {PermissionService} from '../services/permission.service';

@Injectable()
export abstract class AbstractLayoutPageComponent extends AbstractPageComponent {
  protected readonly layoutService = inject(LAYOUT_THEME);
  protected readonly permissionService = inject(PermissionService);
  protected readonly layoutToastService = inject(LayoutToastService);

  override handleCatchError(error: any): Observable<never> {
    this.logger.error(this.name, error);
    this.layoutToastService.showError(error.message);
    return EMPTY;
  }
}
